import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import GuideLink, { useGuideVisible } from '@/components/common/GuideLink';

const AUDIENCES = ['faculty', 'student', 'coordinator'];

/** The step-by-step guides the viewer is meant to see, as a list of links. */
function HowToUseSection() {
    const shown = [
        useGuideVisible('faculty'),
        useGuideVisible('student'),
        useGuideVisible('coordinator'),
    ];
    if (!shown.some(Boolean)) return null;

    return (
        <section className="py-4 border-bottom" aria-labelledby="how-to-use">
            <Container>
                <Row>
                    <Col lg={8} className="mx-auto">
                        <h2 id="how-to-use" className="h4 fw-bold">
                            How to use the Hub
                        </h2>
                        <p>
                            Each guide is a short PDF that walks through the
                            steps, with screenshots.
                        </p>
                        <ul className="mb-0">
                            {AUDIENCES.filter((_audience, i) => shown[i]).map(
                                (audience) => (
                                    <li key={audience}>
                                        <GuideLink audience={audience} />
                                    </li>
                                )
                            )}
                        </ul>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default HowToUseSection;
